import { render, staticRenderFns } from "./travel.vue?vue&type=template&id=ce2b7170&scoped=true&"
import script from "./travel.vue?vue&type=script&lang=js&"
export * from "./travel.vue?vue&type=script&lang=js&"
import style0 from "./travel.vue?vue&type=style&index=0&id=ce2b7170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2b7170",
  null
  
)

export default component.exports